
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import DevaltusfrontImg from '../images/devaltusfront3_flat.png';
import CalendarTable from "./CalendarTable";
import copyBtn from '../images/copyBtn.png';

const tableHeader = ['Description', 'Enabled', 'Start date', 'End date'];
function UserCalendar(props) {
    const { calendars, handleMessage } = props;
    const copyToClipboard = (url) => {
        navigator.clipboard.writeText(url);
        handleMessage({ type: "info", message: "Calendar link copied to your clipboard!" });
    }
    return (
        <div>
            <Row style={{ margin: 0 }}>
                <Col md={8} style={{ marginLeft: '2rem' }}>

                    <Card key="cal-card" style={{ padding: 5 }}>
                        <Card.Body>
                            {calendars?.map(calendar =>
                                <>
                                    <Card.Title key={calendar.name} style={{ textAlign: 'center' }}>{calendar.name}</Card.Title>
                                    {calendar.enabled &&
                                        <>
                                            <Card.Link key={`link-${calendar.url}`} href={calendar.url} target='_blank'>Calendar link</Card.Link>
                                            <Image key={`copy-${calendar.id}`} style={{ marginLeft: 10, marginBottom: 2 }} src={copyBtn} onClick={() => copyToClipboard(calendar.url)} alt='Copy Calendar' />
                                        </>
                                    }
                                    <CalendarTable key={`table-${calendar.id}`} tableHeader={tableHeader} tableData={calendar} />
                                </>
                            )
                            }

                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <div style={{ height: "80%" }}>
                        <Image src={DevaltusfrontImg} fluid height={'auto'} width={'auto'} />
                    </div>
                    <div>Please copy and paste calendar link in your calendar app.</div>
                </Col>
            </Row>
        </div>
    );
}

export default UserCalendar;